/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";

// Material Dashboard 2 PRO React Context Provider
import { MaterialUIControllerProvider } from "context";
import { AuthProvider } from "auth/authProvider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { CustomerProvider } from "providers/CustomerContext";
import { TeamProvider } from "providers/TeamContext";
import { StatusProvider } from "providers/StatusContext";

const queryClient = new QueryClient({
  defaultOptions:{
    queries:{
      refetchOnWindowFocus:false
    }
  }
});

/*
ReactDOM.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <App />
    </MaterialUIControllerProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
*/

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <MaterialUIControllerProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <CustomerProvider>
              <TeamProvider>
                <StatusProvider>
                  <App />
                </StatusProvider>
              </TeamProvider>
            </CustomerProvider>
          </LocalizationProvider>
        </MaterialUIControllerProvider>
      </QueryClientProvider>
    </AuthProvider>
  </BrowserRouter>
);
